<script>
import RequestListWrapper from '../components/RequestListWrapper';

export default {
    name: 'Returned',
    extends: RequestListWrapper,
    data() {
        return {
            status: 'Возвращена потребителю'
        };
    },
    watch: {},
    computed: {},
    methods: {},
    mounted() {}
};
</script>